


export default API => ({
    // 优惠券跳转链接
    getJumpUrl(params) {
        return API({
            url: `/marketing-mix/v1/coupon/getroute`,
            method: 'get',
            params: params
        })
    },
    // 优惠券相关领取信息
    getCouponInfo(params) {
        return API({
            url: `/marketing-mix/v1/coupon/findByUcode`,
            method: 'get',
            params: params
        })
    },
    // 领取优惠券
    getCoupons(params) {
        return API({
            url: `/marketing-mix/v1/couponUser/receive`,
            method: 'get',
            params: params
        })
    },

});
